import { useState } from 'react'
import { authService } from '../services/api'
import '../styles/arboleda.css'

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const res = await authService.login(email, password)
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('usuario', JSON.stringify(res.data.usuario))
      onLogin(res.data.usuario)
    } catch {
      setError('Correo o contraseña incorrectos')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-shell">
      <div className="login-left">
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, color: '#C9A96E' }}>[Arboleda]:</div>
          <div style={{ fontSize: 13, color: '#5A5A50', marginTop: 4 }}>District Cooling System</div>
        </div>
        <h1 style={{ fontFamily: 'Playfair Display, serif', fontSize: 28, color: '#1C1C1A', marginBottom: 8 }}>
          Panel de Administración
        </h1>
        <p style={{ fontSize: 13, color: '#8A8A7A', marginBottom: 32 }}>
          Ingresa tus credenciales para continuar
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Correo electrónico</label>
            <input className="form-input" type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="correo@arboleda.com" required />
          </div>
          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <input className="form-input" type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required />
          </div>
          {error && <p style={{ color: '#993C1D', fontSize: 13, marginBottom: 12 }}>{error}</p>}
          <button className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '10px' }}
            disabled={loading}>
            {loading ? 'Ingresando...' : 'Iniciar sesión'}
          </button>
        </form>
      </div>
      <div className="login-right">
        <div style={{ textAlign: 'center', padding: 40 }}>
          <div className="login-right-title">
            Bienvenido a<br />District Cooling<br />System Arboleda
          </div>
          <p className="login-right-sub">
            Gestión de residentes, tickets y cobranza<br />en un solo lugar
          </p>
        </div>
      </div>
    </div>
  )
}
